<template>
  <div ref="tagGroupContainer" class="x-tag-group" :style="{ margin: `0 -${tagMarginWidth}px` }">
    <div ref="fixedSvgContainer" class="fixed-svg"></div>
    <template v-for="(tag, index) of renderTags">
      <div class="tag-group-box" :key="index" :style="{ margin: `0 ${tagMarginWidth}px` }">
        <template v-if="$scopedSlots.tag">
          <slot name="tag" :tag="tag" :index="index"></slot>
        </template>
        <x-tag v-else :label="tag[calcKey]"></x-tag>
      </div>
    </template>
    <template v-if="tags.length > showCount">
      <div class="tag-more" @click.stop="handleClick">
        <x-svg-icon name="x-lib-more-tag"></x-svg-icon>
      </div>
    </template>
  </div>
</template>

<script>
import XTag from '../x-tag/x-tag'

export default {
  name: 'XTagGroup',
  components: {
    XTag
  },
  props: {
    calcKey: {
      type: String,
      default: 'label'
    },
    tags: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    tagMaxWidth: {
      type: Number,
      default: 0
    },
    maxShowTag: {
      type: Number,
      default: 0
    },
    containerWidth: {
      type: Number,
      default: 0
    },
    tagPaddingWidth: {
      type: Number,
      default: 12
    },
    tagMarginWidth: {
      type: Number,
      default: 4
    },
    tagFontSize: {
      type: Number,
      default: 14
    },
    countWidth: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      calcLimit: 3,
      showCount: 0,
      maxWith: 0
    }
  },
  computed: {
    renderTags() {
      return this.tags.slice(0, this.showCount)
    }
  },
  watch: {
    tags: {
      handler() {
        this.calcRenderCount()
      }
    }
  },
  mounted() {
    this.calcRenderCount()
  },
  methods: {
    calcRenderCount(element) {
      setTimeout(() => {
        if (this.containerWidth === 0) {
          this.maxWidth = this.$refs.tagGroupContainer.clientWidth
        } else {
          this.maxWidth = this.containerWidth
        }
        this.calcTagCount()
      })
    },
    calcTagCount() {
      let tagWidths = []
      let renderCount = 0
      const calcCount = Math.floor(this.tags.length / this.calcLimit) + 1
      for (let index = 0; index < calcCount; index++) {
        const tagTexts = this.tags
          .slice(this.calcLimit * index, this.calcLimit * index + this.calcLimit)
          .map((tag) => {
            return tag[this.calcKey]
          })
        tagWidths = [...tagWidths, ...this.getSvgsWidth(tagTexts)]
        renderCount = this.compareCountWithMaxWidth(tagWidths, this.maxWidth)
        if (
          renderCount < tagWidths.length ||
          (renderCount === tagWidths.length && index === calcCount - 1)
        ) {
          this.showCount = renderCount === 0 ? 1 : renderCount
          return
        }
      }
    },
    getSvgsWidth(texts) {
      // 这里使用div不用fragment主要是不方便删除
      const textsFragment = document.createElement('div')
      const textElements = texts.map((text) => {
        const textElement = document.createElement('span')
        textElement.textContent = text
        textElement.style.fontSize = this.tagFontSize
        textsFragment.appendChild(textElement)
        return textElement
      })
      this.$refs.fixedSvgContainer.appendChild(textsFragment)
      const textElementsWidth = textElements.map((element) => element.getBoundingClientRect().width)
      this.$refs.fixedSvgContainer.removeChild(textsFragment)
      return textElementsWidth
    },
    compareCountWithMaxWidth(widths, maxWidth) {
      let count = 0
      for (let index = 0; index < widths.length; index++) {
        count = count + widths[index] + this.tagMarginWidth * 2 + this.tagPaddingWidth * 2

        if (count >= maxWidth - this.countWidth) {
          return index
        }
      }
      return widths.length
    },
    handleClick() {
      this.$message({
        type: 'info',
        message: this.tags.map((item) => item[this.calcKey]).toString()
      })
    }
  }
}
</script>

<style lang="scss">
.x-tag-group {
  width: 100%;
  flex: 1;
  display: flex;

  > .tag-info {
    display: flex;
    align-items: center;
  }

  .fixed-svg {
    position: fixed;
    width: 3000px;
    height: 3000px;
    opacity: 0;
    top: 0;
    left: 0;
    visibility: hidden;
  }

  .tag-more {
    .x-svg-icon {
      display: flex;
    }
  }
}
</style>
